export default __webpack_public_path__ + "static/media/JakePeck-Resume.389e9daa.pdf";